import _ from 'lodash';
import { ref, computed } from 'vue-demi';
import { useGlobalVars } from './use-global-vars';
import { IAgent } from '@/types';

/**
 * App components receive extra info from launcher so they can navigate back.
 * We use Vue root instance to pass variables since local state would be different between bundles.
 * TODO: Merge $launcher with $globals - will break compatibility
 */
export const useAppLauncherIntegration = () => {
  const { getVueRef, getVueGlobals } = useGlobalVars();

  const initializeRefs = (props: {
    appId?: string;
    launcherAgent?: IAgent;
    isUserAdmin?: boolean;
    goBackToLauncher: () => void;
  }) => {
    getVueGlobals().appId = ref(props.appId || '');
    getVueGlobals().launcherAgent = ref(props.launcherAgent);
    getVueRef().$launcher = {
      isUsingLauncher: true,
      isUserAdmin: props.isUserAdmin || false,
      onGoToLauncher: props.goBackToLauncher || _.noop,
    };
  };

  /** Return all values wrapped in refs for consistency */
  const getRefs = () => {
    const onGoToLauncher = getVueRef().$launcher?.onGoToLauncher || _.noop;
    const appId = computed(() => getVueGlobals().appId?.value as string || '');
    const launcherAgent = computed(() => getVueGlobals().launcherAgent?.value as IAgent | undefined);
    const isUsingLauncher = computed(() => getVueRef().$launcher?.isUsingLauncher || false);

    const showBackToLauncherButton = computed(() => {
      return getVueRef().$launcher?.isUserAdmin && isUsingLauncher.value || false;
    });

    const onGoBack = () => {
      return showBackToLauncherButton.value
        ? onGoToLauncher()
        : window.location.assign(getVueRef().$helpers.actionDeskUrl);
    };

    return { isUsingLauncher, showBackToLauncherButton, appId, launcherAgent, onGoBack };
  };

  return { getRefs, initializeRefs };
};
